import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PcLoadingBarModule } from 'app/shared/components/loading-bar';
import { EmptyLayoutComponent } from 'app/layout/layouts/empty/empty.component';

@NgModule({
  declarations: [EmptyLayoutComponent],
  imports: [RouterModule, PcLoadingBarModule],
  exports: [EmptyLayoutComponent],
})
export class EmptyLayoutModule {}
